import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { IHistoryNormalized } from '../../../../../store/blockList/selector';
import { ProcessCard } from '../ProcessCard';

namespace ProcessHistoryTypes {
  export type Props = {
    data: IHistoryNormalized[];
    loading: boolean;
  };
}

export const ProcessHistory: React.FC<ProcessHistoryTypes.Props> = ({ data, loading }) => {
  return (
    <VStack testID="process-history" space={Spacing['inline.xxxs']}>
      <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
        Acompanhe o processo
      </Text>

      <VStack>
        {data &&
          data.map((item, index) => {
            const isFirstItem = index === 0;
            const isLastItem = index === data.length - 1;

            return (
              <ProcessCard
                key={index.toString()}
                iconName={item.iconName}
                iconColor={item.iconColor}
                iconSize={item.iconSize}
                iconBackground={item.iconBackground}
                title={item.title}
                info={item.info}
                isLastItem={isLastItem}
                isFirstItem={isFirstItem}
              />
            );
          })}

        {loading && (
          <>
            {Array.from({ length: 4 }).map((_, index) => (
              <VStack marginBottom={Spacing['inline.xs']} key={index}>
                <HStack marginBottom={Spacing['inline.xxxs']} alignItems={'center'}>
                  <Skeleton
                    width={18}
                    height={18}
                    borderRadius={'full'}
                    marginRight={Spacing['inline.nano']}
                  />
                  <Skeleton width={'30%'} height="14px" borderRadius={'md'} />
                </HStack>

                <VStack width={'100%'} paddingLeft={Spacing['inline.xs']}>
                  <HStack
                    marginBottom={Spacing['inline.quarck']}
                    alignItems={'center'}
                    justifyContent={'space-between'}>
                    <Skeleton width={'25%'} height="14px" borderRadius={'md'} />
                    <Skeleton width={'25%'} height="14px" borderRadius={'md'} />
                  </HStack>
                  <HStack
                    marginBottom={Spacing['inline.quarck']}
                    alignItems={'center'}
                    justifyContent={'space-between'}>
                    <Skeleton width={'15%'} height="14px" borderRadius={'md'} />
                    <Skeleton width={'15%'} height="14px" borderRadius={'md'} />
                  </HStack>
                  <HStack
                    marginBottom={Spacing['inline.quarck']}
                    alignItems={'center'}
                    justifyContent={'space-between'}>
                    <Skeleton width={'20%'} height="14px" borderRadius={'md'} />
                    <Skeleton width={'20%'} height="14px" borderRadius={'md'} />
                  </HStack>
                </VStack>
              </VStack>
            ))}
          </>
        )}
      </VStack>
    </VStack>
  );
};
